import React, { useState, useCallback, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cropper from "react-easy-crop";
import { Button } from "@/components/Common";

import { useEmpresa } from "@/hooks/empresas";
import AuthActions from "@/store/ducks/auth";

import getCroppedImg from "@/utils/get-cropped-img";
import { ModalContent, ModalFooter } from "./styles";

export default function ModalEditAvatar({ onClose }) {
  const { data: user } = useSelector(state => state.auth);
  const { updateEmpresa, loading } = useEmpresa();
  const dispatch = useDispatch();
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState();
  const inputFile = useRef();
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  useEffect(() => {
    if (!loading) {
      resetModalAndClose();
    }
  }, [loading]);

  const triggerButton = () => {
    inputFile.current.click();
  };

  const handleFileChange = async e => {
    if (e.target.files && e.target.files.length > 0) {
      const imageDataUrl = await readFile(e.target.files[0]);
      setImageSrc(imageDataUrl);
      setCrop({ x: 0, y: 0 });
      setZoom(1);
    }
  };

  const readFile = file => {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  };

  const resetModalAndClose = () => {
    inputFile.current.value = "";
    setZoom(1);
    setImageSrc(null);
    onClose();
  };

  const saveCroppedImage = async () => {
    const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
    updateEmpresa(user.empresa.id, { imagem: croppedImage }).then(res => {
      dispatch(AuthActions.authFetchMe());
    });
  };

  return (
    <ModalContent>
      <h2>Alterar imagem de avatar</h2>
      <input type="file" ref={inputFile} onChange={handleFileChange} />
      <Button variant="magenta" block onClick={triggerButton}>
        Selecionar imagem
      </Button>
      {imageSrc && (
        <>
          <div className="crop-container">
            <Cropper
              cropShape="round"
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              showGrid={false}
              aspect={1}
              cropSize={{ width: 200, height: 200 }}
              onCropChange={setCrop}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            />
          </div>
          <div className="controls"></div>

          <ModalFooter>
            <Button
              loading={loading || undefined}
              variant="cyan"
              block
              onClick={saveCroppedImage}
            >
              Salvar
            </Button>
            <Button variant="cancel" block onClick={resetModalAndClose}>
              Cancelar
            </Button>
          </ModalFooter>
        </>
      )}
    </ModalContent>
  );
}
